var _rect, _rect2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#9d9d9d",
    strokeWidth: 4,
    stroke: "#9d9d9d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 24,
    fill: "#fff",
    strokeWidth: 4,
    stroke: "#9d9d9d"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 8,
    x2: 14,
    y2: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 12,
    x2: 13,
    y2: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 16,
    x2: 14,
    y2: 12,
    stroke: "#fff",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseSidebar);
export default __webpack_public_path__ + "static/media/collapse-sidebar.0a3b6eb4b1c4266cf7bc0c053082f419.svg";
export { ForwardRef as ReactComponent };